import { ListItemText, MenuItem } from "@mui/material"
import { setContextMenuOpened } from "../../actions/contextMenuActions";
import { useDispatch } from "react-redux";

const ContextMenuItem = ({option}) => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(setContextMenuOpened(false));

        option.onClick();
    }

    return (
        <MenuItem onClick={handleClick}>
            <ListItemText>{option.text}</ListItemText>
        </MenuItem>
    )
}

export default ContextMenuItem;